import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import { md, lg, xl, wide, xwide } from '../common';

export function initReviewsSlider() {
  const parent = document.querySelector('.reviews-slider');
  if (!parent) return;

  const swiperEl = parent.querySelector('.reviews-slider__swiper');
  if (swiperEl) {
    const nextEl = parent.querySelector('.swiper-button-next');
    const prevEl = parent.querySelector('.swiper-button-prev');
    const paginationEl = parent.querySelector('.swiper-pagination');

    new Swiper(swiperEl, {
      modules: [Pagination, Navigation],
      slidesPerView: 'auto',
      loop: true,
      spaceBetween: 24,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        [md]: { slidesPerView: 2, spaceBetween: 20 },
        [lg]: { slidesPerView: 3, spaceBetween: 20 },
        [wide]: { slidesPerView: 3, spaceBetween: 24 },
        [xwide]: { slidesPerView: 3, spaceBetween: 32 },
      },
    });
  }
}
